

export class LicenseToDriveOutputData implements ILicenseToDriveOutputData {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id!: number;

    constructor(data?: ILicenseToDriveOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.license_to_drive_id = _data["license_to_drive_id"];
        }
    }

    static fromJS(data: any): LicenseToDriveOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseToDriveOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["license_to_drive_id"] = this.license_to_drive_id;
        return data; 
    }
}

export interface ILicenseToDriveOutputData {
    /** The auto-generated id of the license to drive master */
    license_to_drive_id: number;
}

